import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Button from "../../components/button";
import Footer from "../../components/footer";
import Header from "../../components/header";
import Input from "../../components/input";
import Loader from "../../components/loader";
import { useTranslate } from "../../context/TranslationContext";
import usePostGuidelineController from "../../controllers/usePostGuidelineController";

const CommunityEdit = () => {
  const { t } = useTranslate("communityEdit");
  const { values, functions } = usePostGuidelineController();

  // useEffect(() => {
  //   setMetaTags(
  //     "Traineego | Buy or Create Automated Courses & Tracks for Fitness & Wellness",
  //     "Create, manage, and sell your own courses and tracks, or buy high-quality content. Empower your career through automation and passive income today!",
  //   );
  // }, []);

  return (
    <>
      <Helmet>
        <title>
          Fitness Community Feed | Connect, Learn & Share | Traineego
        </title>
        <meta name="robots" content="noindex,follow" />
      </Helmet>
      <Header />
      <Loader loading={values?.isLoading} />
      <section className="banner">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="text-uppercase">{t("title")}</h1>
            </div>
            <div className="col-12 mt-5 d-flex justify-content-between align-items-center">
              <h4 className="text-uppercase">
                {values?.isEditing ? t("editDiscussion") : t("postDiscussion")}
              </h4>
              <Link
                to="/community"
                className="white-text d-flex gap-2 align-items-center fw-bold p-md"
              >
                <i className="fas fa-angle-left" />
                <p className="mb-0">{t("back")}</p>
              </Link>
            </div>

            <Input
              type="textarea"
              placeholder={t("writeContent")}
              value={values?.content}
              onChange={functions?.onChangeContent}
            />

            <Input
              type="file"
              accept="image/*,image/gif"
              onChange={functions.onChangeImgorgif}
              className="form-control mt-3"
            />

            {values?.imgorgif && (
              <div className="mt-3">
                <p className="mb-2">{t("preview")}</p>
                <img
                  src={`${process.env.REACT_APP_S3_BASE_URL}${values.imgorgif}`}
                  alt="Uploaded preview"
                  style={{
                    maxWidth: "300px",
                    height: "auto",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                    padding: "4px",
                  }}
                />
              </div>
            )}

            <div className="d-flex mt-3 justify-content-end">
              <Button
                text={values?.isEditing ? t("update") : t("post")}
                onClick={functions?.onClickPost}
                disabled={
                  values?.isLoading ||
                  (!values?.content?.trim() && !values?.imgorgif)
                }
              />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default CommunityEdit;
